import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { companyManagementUrl } from "../../../config";

import { useEffect, useState } from "react";

import { PulseLoader } from "react-spinners";
import { BranchColumns } from "../../../data/DynamicTable/CompanyManagementColumns";
import {
  allBranches,
  allCompanyBranches,
  allCompanyBranchesView,
  allRegions,
} from "../../../data/Axios/queries";
import BranchForm from "./form";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import DynamicEditableTable from "../../../data/DynamicTable/EditableDataGrid";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

const base_url = companyManagementUrl.uri;
// const setup_url = setupManagementUrl.uri;
const ignoreFields = [
  "Latitude",
  "Longitude",
  "BranchRadius",
];

const brachesTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This Page is all about Branches, where you can Creates, edit activate or deactivate the Branch.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Branch by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Branch.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each Branches from this dropdown.",
    placement: "left",
  },
];
const actions = {
  entity: "CompanyBranches",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
    // inputObjectName: "updateBranch",
    // InputObject: "updatedBranch",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
    // inputObjectName: "createBranch",
    // InputObject: "newBranch",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  dataObject: {
    ignoreFields,
    objectName: "branch",
    parameters: "",
  },
  showStatus: true,
  showMore:{
    search:false,
    min: 0,
    max:0
  }
};
function BranchTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="Branch"
          subtitle="Create, view or edit  Branch"
          FormComponent={BranchForm}
          base_url={base_url}
          actions={actions}
          tourSteps={brachesTourSteps} // Pass tour steps as prop
        />
      </>
    </Box>
  );
}

export default BranchTable;
